export default function creditCards(state = [], action) {
  const initialState = []
  switch (action.type) {
    case 'RECEIVE_CREDIT_CARDS': {
      return action.payload
    }

    case 'REMOVE_SESSION_CREDIT_CARDS': {
      return initialState
    }

    default:
      return state
  }
}

export function getPrimaryCreditCard(state) {
  if (!state) {
    return null
  }

  const primaryCard = state.find(card => card.primary)

  if (primaryCard) {
    return primaryCard
  } else {
    return state[0]
  }
}
